import { createEvent, createStore } from "effector";
import { ICollection } from "../types/collection";

export const setPickedCollection = createEvent<null | ICollection>();
export const $pickedCollection = createStore<null | ICollection>(null)
.on(setPickedCollection,(_,res)=> res)